import { useContext } from 'react';

import type { TelehealthCallManagerContextValue } from './TelehealthCallManagerContext';
import { TelehealthCallManagerContext } from './TelehealthCallManagerContext';

export function useTelehealthCallManager(): TelehealthCallManagerContextValue {
  const context = useContext(TelehealthCallManagerContext);
  if (!context) {
    throw new Error(
      'useTelehealthCallManager must be used within TelehealthCallManager',
    );
  }
  return context;
}
